























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import DigitalCurrencyTransaction7TransactionStartAndStopSubscriptionIntroduction from './-7-transaction-start-and-stop-subscription-introduction.vue'


const namespace = 'digitalCurrency'


@Component({
  components: {
    DigitalCurrencyTransaction7TransactionStartAndStopSubscriptionIntroduction
  }
})
class DigitalCurrencyTransaction6TransactionStartAndStopSubscriptionButton extends Vue {
  @Prop({ default: '' }) transactionId?: string

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyTransaction', { namespace }) getDigitalCurrencyTransaction?: any

  isVisibleDialog: boolean = false
  isStartSubscriptionIntroduction?: boolean = false
  isStopSubscriptionIntroduction?: boolean = false

  @Watch('isVisibleDialog') updateIsVisibleDialog () {
    if (!this.isVisibleDialog) {
      this.isStartSubscriptionIntroduction = false
      this.isStopSubscriptionIntroduction = false
    }
  }

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleDialog = isVisible
  }


}

export default DigitalCurrencyTransaction6TransactionStartAndStopSubscriptionButton

